import {
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import { useStepperData } from "../../../Helpers/Contexts/stepperContext";
import { useStyles } from "../styles";
import { REGEX } from "../../../Helpers/constant";

const NCACertified = () => {
  const classes = useStyles();
  const { formData, updateFormData } = useStepperData();

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    updateFormData("NCA_Certified__c", value);
    // Reset certificate details if No is selected
    if (value === "No") {
      updateFormData("NCA_Certification_Details__c", "");
    }
  };

  const handleNCACertificateDetailsChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = e.target.value;
    updateFormData("NCA_Certification_Details__c", value);
  };

  return (
    <>
      <Typography
        variant="h1"
        className={`${classes.headerTitle} label required`}
        mb={2}
      >
        Are you NCA certified?
      </Typography>
      <Typography className={classes.headerDescription} mb={4}>
        Let us know if you’re NCA certified
      </Typography>

      <RadioGroup
        row
        value={formData.NCA_Certified__c || ""}
        onChange={handleRadioChange}
      >
        <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
        <FormControlLabel value="No" control={<Radio />} label="No" />
      </RadioGroup>

      {formData.NCA_Certified__c === "Yes" && (
        <>
          <Typography
            variant="subtitle1"
            mb={1}
            mt={3}
            className="label required"
          >
            Enter details
          </Typography>
          <TextField
            multiline
            minRows={3}
            sx={{
              "& .MuiInputBase-input": {
                backgroundColor: "transparent",
                color: "#fff",
              },
            }}
            placeholder="Enter details..."
            fullWidth
            value={formData.NCA_Certification_Details__c || ""}
            onChange={handleNCACertificateDetailsChange}
          />
        </>
      )}
    </>
  );
};

export default NCACertified;
